/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import * as actionTypes from "../actions/actionTypes";

// initialState
const initialState = {
  users: [],
  contractors: [],
};

/**
 * Capture actions dispatched and modify state accordingly
 * @param {*} state -> updated state
 * @param {*} action -> type of action dispatched
 */
const reducer = (state = initialState, action) => {
  switch (action.type) {
    // set users in state
    case actionTypes.SET_USER:
      return {
        ...state,
        users: action.users,
      };

    // set contractors in state
    case actionTypes.SET_CONTRACTOR:
      return {
        ...state,
        contractors: action.contractors,
      };

    default:
      return state;
  }
};

export default reducer;
